module.exports = __webpack_public_path__ + "img/u923.b7aeb7bd.jpg";